import React, { useState, useEffect, useRef } from "react";
import { fetchPhoneNumber, fetchTimeofDay } from "../services/api";
import { NumericFormat, PatternFormat } from "react-number-format";
import { funFacts } from "../data/staticData";
console.log(funFacts);

interface TimeOfDayGameProps {
  selectedCountry: string;
}

const TimeOfDayGame: React.FC<TimeOfDayGameProps> = ({ selectedCountry }) => {
  const [displayNumber, setDisplayNumber] = useState("");
  const [spokenUrl, setSpokenUrl] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [message, setMessage] = useState("");
  const [incorrectFeedback, setIncorrectFeedback] = useState<string | null>(null);
  const [correctCount, setCorrectCount] = useState(0);
  const [nextData, setNextData] = useState<{ spoken: string, spokenurl: string, hour: number, minute: number } | null>(null); // Holds prefetched data
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [targetHour, setTargetHour] = useState("");
  const [targetMin, setTargetMin] = useState("");

  const [showModal, setShowModal] = useState(false); // Modal visibility state

  const funFact = 
    selectedCountry in funFacts.time_game
      ? funFacts.time_game[selectedCountry as keyof typeof funFacts.time_game] 
      : null;

  // Fetch the current question
  const loadTimeOfDay = async () => {
    const data = await fetchTimeofDay(selectedCountry);
    console.log(data);
    setDisplayNumber(data.display);
    setTargetHour(data.hour);
    setTargetMin(data.minute);
    setSpokenUrl(data.spokenurl);
  };

  // Prefetch the next question in the background
  const prefetchNext = async () => {
    console.log("in prefetchNext");
    const next = await fetchTimeofDay(selectedCountry);
    setNextData(next);
  };

  // Initialize by loading the first question and prefetching the next one
  useEffect(() => {
    console.log("first useEffect");
    loadTimeOfDay();
    prefetchNext(); // Prefetch the next question right away
  }, [selectedCountry]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    console.log(inputValue);
    let [hour_str, min_str] = inputValue.split(":");
    let hour = parseInt(hour_str);
    let minute = parseInt(min_str);

    console.log(hour);
    console.log(minute);
    console.log(parseInt(targetHour));
    console.log(parseInt(targetMin));

    if (hour == parseInt(targetHour) && minute == parseInt(targetMin)) {
      setMessage("Correct");
      setCorrectCount((prev) => prev + 1);
      setIncorrectFeedback("");

      setTimeout(() => {
        setMessage("");
        setInputValue("");

        // Move the prefetched question to the current state
        if (nextData) {
          setDisplayNumber(nextData.spoken);
          setTargetHour(nextData.hour.toString());
          setTargetMin(nextData.minute.toString());
          setSpokenUrl(nextData.spokenurl);
          setNextData(null); // Clear out the prefetched data
        }

        // Prefetch the following question in the background
        prefetchNext();
      }, 1000);
    } else {
      setMessage("Incorrect");
      // setIncorrectFeedback(formatFeedback(inputValue, displayNumber));
    }
  };

  const formatFeedback = (input: string, correct: string) => {
    return input
      .split("")
      .map((char, index) => {
        if (char === correct[index]) {
          return `<span style="color: green;">${char}</span>`;
        } else {
          return `<span style="color: red;">${char}</span>`;
        }
      })
      .join("");
  };

  // Play the audio when the spokenUrl is updated after a correct answer
  useEffect(() => {
    console.log("second useEffect");
    if (spokenUrl && audioRef.current) {
      audioRef.current.load(); // Reload the audio with the new source
      audioRef.current.play(); // Play the new audio
    }
  }, [spokenUrl]);

  const numFormat = () => {
    if (selectedCountry === "US") {
      return "(###) ###-####";
    } else if (selectedCountry === "CN") {
      return "### #### ####";
    }
    return "";
  };

  return (
    <div className="time-of-day-game">
      <div className="game-header">
        <h2>Time of Day Quiz</h2>
        {funFact && ( // Show the question mark icon only if a fun fact exists
          <button className="info-btn" onClick={() => setShowModal(true)}>
            ❓
          </button>
        )}
        
      </div>
      <p>Correct answers: {correctCount}</p>

      {spokenUrl && (
        <div>
          <audio ref={audioRef} controls>
            <source src={spokenUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>

          <form onSubmit={handleSubmit}>
          <input 
            type="time" 
            value={inputValue} 
            onChange={(e) => setInputValue(e.target.value)} 
            required
          />
            <button type="submit">Submit</button>
          </form>
        </div>
      )}

      {message && <p>{message}</p>}
      {incorrectFeedback && (
        <p
          dangerouslySetInnerHTML={{ __html: incorrectFeedback }}
        />
      )}
      {showModal && funFact && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Fun Facts</h3>
            <div dangerouslySetInnerHTML={{ __html: funFact }} />
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimeOfDayGame;
